import React from 'react'
import styled from 'styled-components'

import { Icon, Input } from './'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.lightGrey};
    border-radius: 5px;
    padding: 0 5px;
`

export const StyledInput = styled(Input)`
    border: 0;
    margin-left: 5px;
`

export const IconInput = ({icon, ...rest}) => (
    <Wrapper>
        <Icon name={icon} />
        <StyledInput {...rest} />
    </Wrapper>
)